import themeConfig from "@/../siteThemeConfig.js";

const mutations = {


	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////


	ROUTER_IS_BUSY (state, value) {
		state.routerIsBusy = value;
	},

	// Vertical NavMenu

	TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
		state.isVerticalNavMenuActive = value;
	},
	TOGGLE_REDUCE_BUTTON (state, val) {
		state.reduceButton = val;
	},
	UPDATE_MAIN_LAYOUT_TYPE (state, val) {
		state.mainLayoutType = val;
	},
	UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
		state.verticalNavMenuItemsMin = val;
	},
	UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
		state.verticalNavMenuWidth = width;
	},


	// VxAutoSuggest
	/*UPDATE_STARRED_PAGE (state, payload) {

		// find item index in search list state
		const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url);

		// update the main list
		state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val;

		// if val is true add it to starred else remove
		if (payload.val) {
			state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index]);
		} else {
			// find item index from starred pages
			const index = state.starredPages.findIndex((item) => item.url == payload.url);

			// remove item using index
			state.starredPages.splice(index, 1);
		}
	},
	// Navbar-Vertical
	ARRANGE_STARRED_PAGES_LIMITED (state, list) {
		const starredPagesMore = state.starredPages.slice(10);
		state.starredPages = list.concat(starredPagesMore);
	},
	ARRANGE_STARRED_PAGES_MORE (state, list) {
		let downToUp = false;
		let lastItemInStarredLimited = state.starredPages[10];
		const starredPagesLimited = state.starredPages.slice(0, 10);
		state.starredPages = starredPagesLimited.concat(list);

		state.starredPages.slice(0, 10).map((i) => {
			if (list.indexOf(i) > -1) downToUp = true;
		});

		if (!downToUp) {
			state.starredPages.splice(10, 0, lastItemInStarredLimited);
		}
	},
	*/


	// ////////////////////////////////////////////
	// UI
	// ////////////////////////////////////////////

	TOGGLE_CONTENT_OVERLAY (state, val) {
		state.bodyOverlay = val;
	},
	UPDATE_PRIMARY_COLOR (state, val) {
		state.themePrimaryColor = val;
	},
	UPDATE_THEME (state, val) {
		state.theme = val;
	},
	UPDATE_WINDOW_WIDTH (state, width) {
		state.windowWidth = width;
	},
	UPDATE_WINDOW_SCROLL_Y (state, val) {
		state.scrollY = val;
	},

	UPDATE_FAVORITE_PAGE (state, payload) {
		const index = state.favoritos.findIndex((item) => item == payload.identificacao);
		if (payload.val) {
			if (index == -1) {
				state.favoritos.push(payload.identificacao);
				localStorage.setItem('fav', JSON.stringify(state.favoritos));
			}
		} else {
			if (index >= 0) {
				state.favoritos.splice(index, 1);
				localStorage.setItem('fav', JSON.stringify(state.favoritos));
			}
		}
	},
	CLEAR_FAVORITES (state) {
		state.favoritos = [];
		localStorage.setItem('fav', JSON.stringify(state.favoritos));
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	// Updates user info in state and localstorage
	UPDATE_USER_INFO (state, payload) {
		//console.log('mutation UPDATE_USER_INFO', this._vm);
		// Get Data localStorage
		let changesStorage = {};
		let changesLocal = {};
		let userInfo = JSON.parse(localStorage.getItem(themeConfig.userInfoLocalStorageKey)) || state.AppActiveUser;
		for (const property of Object.keys(payload)) {
			/*if (payload[property] != null) {
				state.AppActiveUser[property] = payload[property];
				userInfo[property] = payload[property];
			}*/
			if (state.AppActiveUser[property] != payload[property]) {
				changesLocal[property] = {
					from: state.AppActiveUser[property],
					to: payload[property]
				};
			}
			if (userInfo[property] != payload[property]) {
				changesStorage[property] = {
					from: userInfo[property],
					to: payload[property]
				};
			}
			state.AppActiveUser[property] = payload[property];
			userInfo[property] = payload[property];
		}
		// Store data in localStorage
		localStorage.setItem(themeConfig.userInfoLocalStorageKey, JSON.stringify(userInfo));
	},
	REMOVE_USER_INFO (state, payload) {
		if (localStorage.getItem(themeConfig.userInfoLocalStorageKey)) {
			localStorage.removeItem(themeConfig.userInfoLocalStorageKey);
		}
		Object.keys(state.AppActiveUser).forEach((key) => {
			state.AppActiveUser[key] = null;
		});
	},
	SET_LOGOUT (state, payload) {
		state.logoutAsked = true;
	}
};

export default mutations;
